// Global constants for the application

// Price constants
export const CRJMC_PRICE = 54.99;

// URL patterns that are exempt from automatically loading promo codes from cache
// If the current URL matches any of these patterns, promo codes will only be applied
// if explicitly specified in the URL query parameters
export const PROMO_EXEMPT_URL_PATTERNS = ["payment-success"];

// Utility function to calculate discounted price
export const calculateDiscountedPrice = (
  basePrice: number,
  discountPercent: number,
): number => {
  const discountAmount = basePrice * (discountPercent / 100);
  return parseFloat((basePrice - discountAmount).toFixed(2));
};
